module.exports = __webpack_public_path__ + "media/images/favicon-c713cac5c862e63fcb12ed4f198c96b8.png";